import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../../_core/_services/api.service';
import { DepositConfirmationVm } from '../../_core/_model/payments';

@Injectable({ providedIn: 'root' })
export class DepositConfirmationResolver implements Resolve<DepositConfirmationVm | null> {
  constructor(private api: ApiService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<DepositConfirmationVm | null> {
    const depositId = route.paramMap.get('depositId');

    if (!depositId) {
      this.router.navigate(['/account'], {
        queryParams: { tab: 'wallets' },
        replaceUrl: true
      });
      return of(null);
    }

    const nav = this.router.getCurrentNavigation();
    const stateData =
      nav?.extras?.state?.['depositConfirmation'] ??
      history.state?.depositConfirmation ??
      null;

    if (stateData && stateData.depositId === depositId) {
      return of(stateData as DepositConfirmationVm);
    }

    return this.api.getDeposit(depositId).pipe(
      map((res) => {
        const d = res?.data;
        if (!d) return null;

        return {
          depositId: d.depositId,
          walletId: d.walletId ?? null,
          externalReference: d.externalReference,
          status: d.status,
          amount: d.amount,
          currencyCode: d.currency?.code ?? (d as any).currencyCode ?? '',
          gatewayCode: d.gateway?.code ?? null,
          gatewayName: d.gateway?.name ?? null,
          gatewayReference: d.gatewayReference ?? null,
          checkoutType: d.checkoutType ?? null,
          checkoutUrl: d.checkoutUrl ?? null,
          createdAt: d.createdAt,
          lastUpdatedAt: d.lastUpdatedAt,
          confirmedAt: null
        } as DepositConfirmationVm;
      }),
      catchError(() => of(null))
    );
  }
}
